import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { AFFILIATE_REQUESTS_STATUS_TRANSLATIONS } from '../../../../services/data/data-constants-translations';
import moment from 'moment';

@Component({
  selector: 'gtd-ui-field-default-affiliate-request-status-history',
  templateUrl: './affiliate-request-status-history.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AffiliateRequestStatusHistoryComponent implements OnInit {
  @Input() data: {
    changed_at: string;
    changed_by: string;
    status_changed: string;
  };
  @Input() title: string;
  @Input() text: string = $localize`:@@common.show:Show`;
  mappedData = [];
  statusTranslations = AFFILIATE_REQUESTS_STATUS_TRANSLATIONS;

  ngOnInit() {
    if (!this.data) {
      return;
    }
    const item = {
      status: this.data.status_changed?.toLowerCase(),
      changed_by_name: this.data.changed_by,
      changed_at: this.data.changed_at,
    };
    this.mappedData.push({ name: ' ' });
    item.changed_at = moment(item.changed_at).format('DD/MM/yyyy HH:mm:ss');
    this.mappedData.push({
      name: $localize`:@@common.status_sey_by_at:Status "${this.statusTranslations[item.status]}" was set by ${item.changed_by_name} at ${
        item.changed_at
      }`,
    });
  }
}
